import React from 'react';

import { KeyboardDatePicker } from "@material-ui/pickers";
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import ReactSelect from 'react-select';
import Select from '@material-ui/core/Select';

import roleConfig from '../../configs/roles';

import { OTHER_PAYMENTS_TYPE } from '../../utils/listPaymentsType';
import FormControl from '@material-ui/core/FormControl';

import CalendarToday from '@material-ui/icons/CalendarToday';
import { Search as SearchIcon} from '@material-ui/icons';

import commonStyles from '../common/common.module.css';

import { Moment } from 'moment';

import CompanyModel from '../../models/ForwarderAwb';
import AirlineType from '../../models/AirlineType';
import { Checkbox, CircularProgress, FormControlLabel } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

const styles = (theme: Theme) =>

  createStyles({
    wrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      alignItems: 'flex-end',
      borderRadius: '15px',
      marginBottom: '30px',
      padding: '20px',
      backgroundColor: 'var(--greybkg)',
    },
    header: {
      fontWeight: 600,
      color: 'var(--primaryblue)',
      fontSize: '16px',
      marginTop: '0',
    },
    wrapper2:{
      display: 'flex',
      width: '100%',
      flexWrap: 'wrap',
      gap: '20px',
    },
    dateWrapper: {
      display: 'flex',
      flex: '6%',
      gap: '20px',
    },
    typeWrapper: {
      display: 'flex',
      justifyContent: 'space-evenly',
      flex: '15%',
      gap: '20px',
    },
    blue: {
      color: 'var(--primaryblue)',
      fontSize: '14px'
    },
    progress: {
      marginTop: '32px',
      animation: 'none'
    },
    reactSelect: {
      width: '100%',
      fontSize: '14px'
    },
    select: {
      '&:last-child':{
        marginRight: '0px'
      }
    },
    selectFrw: {
      flex: '1 1 150px',
      zIndex: 1,
      '& .css-yk16xz-control, & .css-1pahdxg-control, & .css-1fhf3k1-control':{
        border: '1px solid transparent',
        borderRadius: 'var(--ip-br)',
        fontSize: '13px',
        minHeight: '27px !important',
        height: '27px !important',
        boxShadow: 'none',
        '&:hover':{
          border: '1px solid var(--primaryblue)',
        }
      },
      '& .css-tlfecz-indicatorContainer, & .css-1gtu0rj-indicatorContainer': {
        padding: '0 4px' 
      },
      '& .css-1okebmr-indicatorSeparator, & .css-109onse-indicatorSeparator':{
        display: 'none'
      },
      '& .css-g1d714-ValueContainer': {
        padding: '0 8px' 
      },
      '& .css-1hwfws3':{
        position: 'static'
      }
    },
    selectCarrier: {
      flex: '10%',
    },
    button: {
      minWidth: '30px',
      height: '30px',
      padding: 0,
    },
    iconSearch: {
      fontSize: '18px',
    },
    btnWrapper: {
      paddingTop: '14px',
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '10px',
      marginLeft: 'auto'
    },
    root: {
      color: 'grey',
      height:'5px',
      fontSize: '0.875rem',
    },
    selected: {
      color: 'var(--primaryblue) !important'
    },
    mr:{
      paddingRight:' 0px'
    },
    pl:{
      paddingLeft: '12px'
    },
    menuItem: {
      padding: '10px',
      marginBottom: '2px',
      '&:hover': {
        backgroundColor: 'transparent !important',
        color: 'var(--primaryblue) !important',
        fontSize: '16px !important',
      },
      '&:focus': {
        backgroundColor: 'transparent !important' ,
        '&:hover': {
          backgroundColor: 'transparent !important',
          color: 'var(--primaryblue) !important',
          fontSize: '16px !important',
        },
      },
      '&$selected': { 
        backgroundColor: 'var(--primaryblue) !important',
        color: 'white !important',
        '&:hover': {
          backgroundColor: 'var(--primaryblue) !important',
          color: 'white !important',
        },
        '&:focus': {
          backgroundColor: 'var(--primaryblue) !important',
          color: 'white !important',
          '&:hover': {
            backgroundColor: 'var(--primaryblue) !important',
            color: 'white !important',
          },
        }
      }
    },
    menuItemSelect: {
      minnHeight: '5px',
      background: 'var(--primaryblue)',
      color: 'white',
      marginBottom: '5px',
      justifyContent: 'center',
      lineHeight: 'normal',
      fontSize: '0.9rem',
      '&:hover, &:focus': {
        backgroundColor: 'var(--primaryblue) !important',
        fontSize: '1rem',
      },
    },
    listSubheader: {
      borderBottom: '1px solid grey',
      marginBottom: '5px'
    },
    fieldWrapper:{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      flex: '1 1 150px',
    },
    inputtextField:{
      minWidth: '150px'
    },
  });

interface PaymentReportSearchProps {
  classes: any;
  userId: number;
  startDate: Moment;
  endDate: Moment;
  companyID: any;
  listCompanies: Array<CompanyModel>;
  listPaymentType: Array<{value: string, name: string }>;
  listFeeType: Array<{value: string, name: string }>;
  valuePaymentType: string;
  selectedFeeType: Array<string>;
  handleChangeDate: (dateType: string, event: any) => void;
  handleChangeSelectOption: ( event: any, type: string) => void;
  handleChangeFeeType: Function;
  search: () => void;
  airlineValue: string;
  airlines: AirlineType[];
  settled: boolean;
  overpaid: boolean;
  underpaid: boolean;
  settledPayments: (type: string) => void;
  progressBar: boolean;
};

interface Option {
  value: number;
  label: string;
};

const paymentReportSearch = (props: PaymentReportSearchProps) => {


  const options: Array<Option> = props.listCompanies.map((item: any) => (
    {
      value: item.id,
      label: item.name
    }
  ));

  const getForwarderValue = (): Option => {
    const value: Array<Option> = options.filter((fwd: any) => fwd.value === props.companyID);
    return value[0];
  }

  const { startDate, endDate, companyID, listCompanies, listPaymentType, selectedFeeType, listFeeType, valuePaymentType, classes } = props;
  const selectValue: any = companyID !== 0 ? getForwarderValue() : null;
  const selectTitle: string = props.userId === roleConfig.roleId.forwarderUser ? 'GHA' : 'Forwarder';
 
  const MenuProps = {
    PaperProps: {
      style: {
        width: 250,
      },
    },
  };

  return (
    <div className={ `${ classes.wrapper }` } >
      <h3 className={ classes.header }> Report Filters </h3>
      <div className={ classes.wrapper2 }>
        <FormControl className={ [classes.select, classes.selectFrw].join(" ") }>
          <div className={ commonStyles.inputLabel }>{ selectTitle }</div>
          <ReactSelect 
            onChange={ (event: any) => props.handleChangeSelectOption( event, 'companies') }
            options={ options }
            className={ classes.reactSelect }
            value={ selectValue }
            placeholder={ selectTitle }
            inputProps={{
              name: 'companies',
              id: 'companies',
              classes: {
                icon: classes.blue,
                classes: { root: classes.inputtextField }
              }
            }}
            isClearable={ true }
          />
        </FormControl>

        <div className={ `${ classes.fieldWrapper } ${ classes.selectCarrier }` }>
          <div className={ commonStyles.inputLabel }>Carrier</div>
          <FormControl className={ `${ classes.select } ${ classes.inputtextField }` }>
            <Select
              native
              id="airlineValue"
              name="airlineValue"
              onChange={ (event) => props.handleChangeSelectOption(event, 'airline') }
              value={props.airlineValue}
              className={ classes.paymentSelect }
              variant='outlined'
              fullWidth
            >
              <option value=''/>
              { props.airlines.map((airline: AirlineType) => {
                  return (<option value={ airline.id } key={ airline.id }>{ airline.name + '-' + airline.awb_code }</option>);
                })
              }
            </Select>
          </FormControl>
        </div>
  
        <div className={ classes.dateWrapper } >

          <div className={ classes.fieldWrapper }>
            <div className={ commonStyles.inputLabel }>Start Date</div>
            <KeyboardDatePicker
              autoOk
              className={ `${ classes.datePicker } ${ classes.ipField }` }
              value={ startDate }
              format={ 'DD MMM YYYY' }
              onChange={ (date) => props.handleChangeDate('startDate', date) } 
              InputProps={{ 
                className: classes.blue ,
                classes: { root: classes.inputtextField }
              }}
              inputVariant='outlined'
            />
          </div>
      
          <div className={ classes.fieldWrapper }>
            <div className={ commonStyles.inputLabel }>End Date</div>
            <KeyboardDatePicker
              autoOk
              className={ `${ classes.datePicker } ${ classes.ipField }` }
              value={ endDate }
              format={ 'DD MMM YYYY' }
              onChange={ (date) => props.handleChangeDate('endDate', date) } 
              minDate={ startDate }
              InputProps={{ 
                className: classes.blue ,
                classes: { root: classes.inputtextField }
              }}
              inputVariant='outlined'
            />
          </div>

        </div>

        <div className={ classes.typeWrapper }>
          <div className={ classes.fieldWrapper } >

            <div className={ commonStyles.inputLabel }>Payment Type</div>
            <FormControl className={ `${ classes.select } ${ classes.inputtextField }` }>

              <Select native
                onChange={ (event) => props.handleChangeSelectOption( event, 'paymentType') }                
                className={ `${ classes.blue } ${ classes.paymentSelect }` }
                value={ valuePaymentType }
                inputProps={{
                  name: 'paymentType',
                  id: 'paymentType',
                  classes: {
                    icon: classes.mr
                  }
                }}
                variant='outlined'
                fullWidth
              >
                { listPaymentType.map((type: {value: string, name: string}, index: number) => (
                  <option key={ index } value={ type.value }>{ type.name }</option>
                )) }
                <optgroup label="Other Payments"></optgroup>
                { OTHER_PAYMENTS_TYPE.map((type: {value: string, name: string}, index: number) => (
                  <option key={ index } value={ type.value }>{ type.name }</option>
                )) }
              </Select>

            </FormControl>
          </div>

          <div className={ classes.fieldWrapper } style={{ width: '150px'}}>
            <div className={ commonStyles.inputLabel }>Fee Type</div>
            <FormControl className={ `${ classes.select } ${ classes.inputtextField }` }>

              <Select 
                multiple            
                onChange={ (event)=> props.handleChangeFeeType(event) }
                className={ `${ classes.blue } ${ classes.paymentSelect }` }
                value={ selectedFeeType }
                MenuProps={ MenuProps }
                inputProps={{
                  classes: {
                    icon: classes.mr
                  }
                }}
                variant='outlined' 
                fullWidth
              >
                <MenuItem value = 'select all' className={ classes.menuItemSelect }>Select all</MenuItem>

                <MenuItem value = 'deselect all' className={ classes.menuItemSelect }>Deselect all</MenuItem>

                <ListSubheader className={ classes.listSubheader }/>
        
              { listFeeType.map((type: any)=> (
                <MenuItem 
                  key={ type.value } 
                  value={ type.value } 
                  classes = {{
                    root: classes.root,
                    selected: classes.selected
                }}
                className={ classes.menuItem }
                >
                  { type.name }
                </MenuItem>
              ))}
              </Select>

            </FormControl>
          </div>
         
        </div>
        <div className={ commonStyles.mt2 }>
          <FormControlLabel
            value=""
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                checkedIcon={<CheckBoxIcon color="primary"/>}
                classes={{
                  root: classes.checkbox,
                }}
                onChange={ () => props.settledPayments('overpaid') }
                checked={ props.overpaid }
              />
            }
            label={'Overpaid'}
            className={ classes.completeLabel }
          />
          <FormControlLabel
            value=""
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                checkedIcon={<CheckBoxIcon color="primary"/>}
                classes={{
                  root: classes.checkbox,
                }}
                onChange={ () => props.settledPayments('underpaid') }
                checked={ props.underpaid }
              />
            }
            label={'Underpaid'}
            className={ classes.completeLabel }
          />
          <FormControlLabel
            value=""
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                checkedIcon={<CheckBoxIcon color="primary"/>}
                classes={{
                  root: classes.checkbox,
                }}
                onChange={ () => props.settledPayments('audit') }
                checked={ props.settled }
              />
            }
            label={'Pending Audit'}
            className={ classes.completeLabel }
          />
        </div>
        
        <div className={classes.btnWrapper} >
          {props.progressBar && <CircularProgress className={classes.progress} />}
          {!props.progressBar && <Button
            color="primary"
            variant="contained"
            onClick={props.search}
            className={classes.button}
          >
            <SearchIcon
              className={classes.iconSearch} />
          </Button>
          }

        </div> 

      </div>
             
    </div>
  )
};

export default withStyles(styles)(paymentReportSearch);